module.exports = require("pkcs7");